import { Link } from 'react-router-dom';
import Logo from '../assets/Logo';
import './Footer.scss';

const nav = [
  { label: 'How It Works', to: '/how-it-works' },
  { label: 'Who We Serve', to: '/who-we-serve' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
];

const legal = [
  { label: 'Privacy Policy', to: '#' },
  { label: 'Terms of Use', to: '#' },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__grid">
          <div className="footer__brand">
            <Logo inverted height={24} />
            <p className="footer__tagline">Powering Trade</p>
          </div>

          <div>
            <p className="footer__col-title">Navigation</p>
            <ul className="footer__links">
              {nav.map(({ label, to }) => (
                <li key={to}>
                  <Link to={to} className="footer__link">{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="footer__col-title">Legal</p>
            <ul className="footer__links">
              {legal.map(({ label, to }) => (
                <li key={label}>
                  <Link to={to} className="footer__link">{label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copy">
            &copy; {new Date().getFullYear()} OneLedger Capital. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
